module.exports = __webpack_public_path__ + "img/successPayment.82d94c56.svg";